import { GiphyFetch } from '@giphy/js-fetch-api';
import { Grid } from '@giphy/react-components';
import debounce from 'lodash/debounce';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { IconSpinner, Modal } from '../../../../components';
import { manageDisableScrolling } from '../../../../ducks/ui.duck';
import { handleGifsUpload } from '../../../../util/circleHelper';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from './CreatePostForm.module.css';
import poweredByGiphy from '../../../../assets/images/powerdByGiphy.png';
// const gf = new GiphyFetch('EV5W970Y4KjFSqKJaFDRpmkLQv3yD1KR');
const gf = new GiphyFetch(process.env.REACT_APP_GIPHY_API_KEY);
const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

const handleGifSelection = async (
  event,
  form,
  values,
  dispatch,
  onGiphyChange,
  formOldValues,
  setFormOldValues
) => {
  try {
    // Fetch the GIF (use downsized or original, not mp4)
    const gifUrl = event?.images?.downsized?.url || event?.images?.original?.url;
    const response = await fetch(gifUrl);
    const blob = await response.blob();
    const file = new File([blob], 'giphy.gif', { type: 'image/gif' });
    const uploadResult = await handleGifsUpload(file, dispatch);

    if (!uploadResult || !uploadResult.signed_id) {
      throw new Error('Invalid upload response');
    }

    // Handle both cases: with setFormOldValues (create post) and without (comments/replies)
    if (setFormOldValues && typeof setFormOldValues === 'function') {
      setFormOldValues(prev => ({
        ...prev,
        gifs: [...(prev?.gifs || []), uploadResult],
        giffiles: [
          ...(prev?.giffiles || []),
          {
            file: event?.images?.original?.url,
            signed_id: uploadResult?.signed_id,
          },
        ],
      }));
    }

    if (form && form.change) {
      const currentValues = form.getState?.().values || values || {};
      form.change('gifs', [...(currentValues.gifs || []), uploadResult]);
      form.change('giffiles', [
        ...(currentValues.giffiles || []),
        {
          file: event?.images?.original?.url,
          signed_id: uploadResult?.signed_id,
        },
      ]);
    }

    onGiphyChange();
  } catch (error) {
    console.error('GIF upload failed:', error);
    // Don't throw - just log the error and close modal
    onGiphyChange();
  }
};
const gridWidth = isMobile ? '100%' : 650;
const columns = isMobile ? 2 : 4;
const gutter = isMobile ? 3 : 6;

const GifUploadModal = props => {
  const {
    isGiphyOpen,
    onGiphyChange,
    form,
    values,
    requestDirectUpload,
    formOldValues,
    setFormOldValues,
    usePortal = false,
  } = props;
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState('horse');

  const debouncedSearch = useCallback(
    debounce(value => {
      setSearchTerm(value || 'horse');
    }, 500),
    []
  );

  const handleGifSearch = e => {
    const value = e.target.value;
    debouncedSearch(value);
  };
  return (
    <div>
      <Modal
        id={'gifUploadModal'}
        isOpen={isGiphyOpen}
        onClose={() => !requestDirectUpload && onGiphyChange()}
        className={css.uploadModals}
        onManageDisableScrolling={manageDisableScrolling}
        usePortal={usePortal}
      >
        {requestDirectUpload ? (
          <div className={css.loader}>
            <IconSpinner type={true} />
          </div>
        ) : (
          <div className={css.gifWrapper}>
            <div className={css.heading}>
              <FormattedMessage id="Circle.gifModalTitle" />
            </div>
            <div>
              <div className={css.gifInput}>
                <input
                  type="text"
                  placeholder="Search GIPHY"
                  onChange={handleGifSearch}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
              <div className={css.gifGridBox}>
                <Grid
                  key={searchTerm}
                  width={gridWidth}
                  columns={3} // Number of columns
                  fetchGifs={offset => gf.search(searchTerm, { offset, limit: 10 })}
                  gutter={gutter} // Space between GIFs
                  onGifClick={event =>
                    handleGifSelection(
                      event,
                      form,
                      values,
                      dispatch,
                      onGiphyChange,
                      formOldValues,
                      setFormOldValues
                    )
                  }
                  noLink={true}
                />
              </div>
              <div className={css.powerdByGiphy}>
                <img src={poweredByGiphy} />
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default GifUploadModal;